var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "repeat-box" },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          attrs: {
            rules: _vm.rules,
            model: _vm.form,
            "label-width": "80px",
            "label-position": "left",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "重复" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "选择重复类型" },
                  on: { change: _vm.changeRepeat },
                  model: {
                    value: _vm.form.repetitionType,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "repetitionType", $$v)
                    },
                    expression: "form.repetitionType",
                  },
                },
                _vm._l(_vm.repeatList, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.form.repetitionType != 1
            ? [
                _c(
                  "el-form-item",
                  {
                    staticClass: "form_1",
                    staticStyle: { whiteSpace: "nowrap" },
                    attrs: { label: "重复频率", prop: "repeatRate" },
                  },
                  [
                    _c("el-input", {
                      attrs: { type: "number", min: "0", autocomplete: "off" },
                      model: {
                        value: _vm.form.repeatRate,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "repeatRate", _vm._n($$v))
                        },
                        expression: "form.repeatRate",
                      },
                    }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.timeList[_vm.form.repetitionType])),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.form.repetitionType != 2 && _vm.form.repetitionType != 5
                  ? _c(
                      "el-form-item",
                      {
                        staticClass: "form_1",
                        attrs: { label: "重复时间", prop: "repeatTime" },
                      },
                      [
                        _vm.form.repetitionType == 3
                          ? _c(
                              "el-checkbox-group",
                              {
                                on: { change: _vm.changeRepeatTime },
                                model: {
                                  value: _vm.checkedRepeatTime,
                                  callback: function ($$v) {
                                    _vm.checkedRepeatTime = $$v
                                  },
                                  expression: "checkedRepeatTime",
                                },
                              },
                              _vm._l(_vm.repeatTimeList, function (item) {
                                return _c("el-checkbox", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }),
                              1
                            )
                          : _c(
                              "el-select",
                              {
                                model: {
                                  value: _vm.form.repeatTime,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "repeatTime", $$v)
                                  },
                                  expression: "form.repeatTime",
                                },
                              },
                              _vm._l(_vm.dayList, function (item) {
                                return _c("el-option", {
                                  key: item,
                                  attrs: { label: item, value: item },
                                })
                              }),
                              1
                            ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "form_radio",
                    attrs: { label: "结束", prop: "endTypeConfig" },
                  },
                  [
                    _c(
                      "el-radio-group",
                      {
                        on: { change: _vm.changeEndDate },
                        model: {
                          value: _vm.form.endType,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "endType", $$v)
                          },
                          expression: "form.endType",
                        },
                      },
                      [
                        _c("el-radio", { attrs: { label: "1" } }, [
                          _vm._v("从不"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-radio",
                          { attrs: { label: "2" } },
                          [
                            _vm._v("重复\n            "),
                            _c("el-input", {
                              staticClass: "radio_input",
                              attrs: {
                                disabled: !(_vm.form.endType == 2),
                                type: "number",
                              },
                              model: {
                                value: _vm.endCount,
                                callback: function ($$v) {
                                  _vm.endCount = $$v
                                },
                                expression: "endCount",
                              },
                            }),
                            _vm._v(" 次以后\n          "),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-radio",
                          { attrs: { label: "3" } },
                          [
                            _c("span", { staticClass: "date_span" }, [
                              _vm._v(" 结束日期"),
                            ]),
                            _vm._v(" "),
                            _c("el-date-picker", {
                              staticClass: "form_date",
                              attrs: {
                                disabled: !(_vm.form.endType == 3),
                                "value-format": "yyyy-MM-dd HH:mm:ss",
                                type: "datetime",
                                placeholder: "选择日期",
                              },
                              model: {
                                value: _vm.endDate,
                                callback: function ($$v) {
                                  _vm.endDate = $$v
                                },
                                expression: "endDate",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            { staticClass: "form_bottom", attrs: { label: "摘要" } },
            [
              _c("div", {
                staticClass: "bottom-text",
                domProps: { textContent: _vm._s(_vm.summaryText()) },
              }),
            ]
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }